/**
 * initial setup for jquery elements
 */
define('atn/jquerySetup',['jquery', 'knockout', './config', 'lodash'],
    function($, ko, config, _) {
        'use strict';
        /**
         * flag for showing No Internet Connection message
         * @type {boolean}
         */
        var noConnection = ko.observable(false);
        /**
         * variable to hold timer to close no-connection message
         * @type {object}
         */
        var timer = null;

        /**
         * generic ajax properties to be used throughout the application
         */
        $.ajaxSetup({
            timeout: 300000 // miliseconds
        });
        /**
         * setting ajaxSetup to :
         * 1. redirect user to login page in case
         *    "Login Required" (401) error-code is recieved
         * 2. Show 'No Internet connection' message in case of
         *    no internet connection
         */
        $(document).ajaxError(function(e, xhr) {
            if (!xhr.readyState && config.ajaxTimeoutStatusText !== xhr.statusText) {
                //not connected to internet
                noConnection(true);
                timer = window.setTimeout(function() {
                    noConnection(false);
                }, 3000);
            }
        });
        
        /**
         * Fix to avoid navigation back on backspace. Backspace will now work
         * only on input fields
         *
         * Code directly taken from:
         * http://stackoverflow.com/questions/1495219/how-can-i-prevent-the-backspace-key-from-navigating-back
         */
        $(document).unbind('keydown').bind('keydown', function(event) {
            var doPrevent = false;
            if (event.keyCode === 8) {
                var d = event.srcElement || event.target;
                if ((d.tagName.toUpperCase() === 'INPUT' &&
                        !(
                            d.type.toUpperCase() === 'CHECKBOX' ||
                            d.type.toUpperCase() === 'RADIO' ||
                            d.type.toUpperCase() === 'SUBMIT' ||
                            d.type.toUpperCase() === 'BUTTON')
                    ) ||
                    d.tagName.toUpperCase() === 'TEXTAREA') {
                    doPrevent = d.readOnly || d.disabled;
                } else {
                    doPrevent = true;
                }
            }

            if (doPrevent) {
                event.preventDefault();
            }
        });

        return {
            noConnection: {
                visible: noConnection,
                close: closeNoConnection
            }
        };
        /**
         * function to close no-connection message at click of close icon
         * @return {undefined}
         */
        function closeNoConnection() {
            if (timer) {
                clearTimeout(timer);
            }
            noConnection(false);
        }
    });
